module.exports = __webpack_public_path__ + "assets/img/benefit-draw-8b6c7094.png";